/* tslint:disable */

declare var Object: any;
export interface TscalendarserviceInterface {
  "id"?: number;
}

export class Tscalendarservice implements TscalendarserviceInterface {
  "id": number;
  constructor(data?: TscalendarserviceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Tscalendarservice`.
   */
  public static getModelName() {
    return "Tscalendarservice";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Tscalendarservice for dynamic purposes.
  **/
  public static factory(data: TscalendarserviceInterface): Tscalendarservice{
    return new Tscalendarservice(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Tscalendarservice',
      plural: 'Tscalendarservices',
      path: 'Tscalendarservices',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Tscalendarservice.ts